import { render, staticRenderFns } from "./ScreenObsequiosGerencia.vue?vue&type=template&id=086c6398"
import script from "./ScreenObsequiosGerencia.vue?vue&type=script&lang=js"
export * from "./ScreenObsequiosGerencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports